import React, { useEffect, useState } from 'react';
import {
	ApplicationRoundDocument,
	DayTimeSlot,
	OfflineDriveCandidate,
	SlotTime,
	UIApplicationRound,
	UIOfflineDriveRoundDetail,
	UISkill,
	UIUserAvailability,
} from 'types';
import { Drawer } from '../../shared/Drawer';
import OpportunityTable from './OpportunityTable';
import { useParams } from 'react-router-dom';

interface Props {
	openOpportunityDrawer: boolean;
	setOpenOpportunityDrawer: (open: boolean) => void;
	candidate: OfflineDriveCandidate;
	driveId: string;
}

export const OpportunityDrawer = ({ openOpportunityDrawer, setOpenOpportunityDrawer, candidate, driveId }: Props) => {
	const { positionId } = useParams();
	const [candidateRounds, setCandidateRounds] = useState<UIOfflineDriveRoundDetail[]>([]);
	const handleClose = () => {
		setOpenOpportunityDrawer(false);
	};

	useEffect(() => {
		if (candidate?.roundsDetails) {
			setCandidateRounds(
				candidate.roundsDetails?.filter(round =>
					positionId ? round?.position?._id?.toString() === positionId?.toString() : true,
				) || [],
			);
		}
	}, [candidate?.roundsDetails]);

	return (
		<div>
			<Drawer
				fullWidth
				isOpen={openOpportunityDrawer}
				onClose={handleClose}
				maxHeight="80vh"
				minHeight="40vh"
				boxShadow="0px -8px 32px 0px #00000040"
				header={
					<div className="flex flex-col gap-2.5 pt-5 px-3">
						{/* <h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4">Status</h1> */}
						<h1 className="text-[#1F3343] text-lg font-medium leading-[140%] mb-2">
							User's rounds in this drive: <span className="font-bold">{candidateRounds.length}</span>
						</h1>
						<div className="w-full h-[1.3px] flex-shrink-0 rounded bg-gray-200" />
					</div>
				}
				body={
					<div className="py-4 px-3">
						<OpportunityTable driveId={driveId} candidateRounds={candidateRounds} isPlaced={candidate?.isPlaced} />
					</div>
				}
			/>
		</div>
	);
};
